export default __webpack_public_path__ + "static/media/telegram.99c88310.svg";